import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectEssSwitch } from 'shared/slice/essSwitchSlice';
import { selectGlobalOverview } from 'features/globalOverview/slice/globalOverviewSlice';
import { selectTesSwitch } from 'shared/slice/tesSwitchSlice';
import { selectTgsSwitch } from 'shared/slice/tgsSwitchSlice';
import {
  handleOpenMasterControl,
  selectMCIsExpanded,
} from 'shared/slice/MCIsExpandedSlice';
import { selectUserInfo } from 'shared/slice/userSlice';

import styled, { css } from 'styled-components';
import {
  flexBoxCenter,
  justifyContentSpaceBetween,
  layerA180Deg,
  layerADark,
  layerADisabled180Deg,
  layerB,
  layerBDark,
  layerBDisabled,
  layerC,
} from 'shared/styles/commonStyles';

import DisplayMachineSuggestion from './DisplayMachineSuggestion';
import SwitchLocation from './SwitchLocation';
import IndividualMachine from './IndividualMachine';
import {
  filteredSuggestionsHandler,
  getFormattedMachineName,
} from 'shared/helpers/helpers';
import {
  countSwitchTreeDevices,
  filterSwitchTree,
} from 'shared/helpers/filterSwitchTree';
import { useLocations, useSetZoneOpeningsState } from 'shared/hooks';
import { countHpSegments, hpStations } from 'features/heatingPlatform/components/stationsData';
import HpStationLocation from './HpStationLocation';

const IntegratedSystem = ({ setCenter, setZoomNum ,mapCenter,zoomNum,selectedLocation,setSelectedLocation}) => {
  const MCIsExpanded = useSelector(selectMCIsExpanded);


  const userInfo = useSelector(selectUserInfo);
  const { isEssSwitch, isTesSwitch, isTgsSwitch, isHpSwitch, isAteSwitch } =
    userInfo;

  const { essSwitch, flatEssSwitch } = useSelector(selectEssSwitch);

  const { tgsSwitch, flatTgsSwitch } = useSelector(selectTgsSwitch);
  const { tesSwitch, flatTesSwitch } = useSelector(selectTesSwitch);
  const filteredEssSwitch = filterSwitchTree(essSwitch);
  const filteredTgsSwitch = filterSwitchTree(tgsSwitch);
  const filteredTesSwitch = filterSwitchTree(tesSwitch);
  const locations = useLocations();

  const overViewState = useSelector(selectGlobalOverview);
  const { selectedSystem } = overViewState;

  const [inputSearch, setInputSearch] = useState(['', '', '', '', '']);
  const [searchedMachines, setSearchedMachines] = useState(['', '', '']);
  const handleInputChange = (e, index) => {
    const updatedSearchedMachines = [...searchedMachines];
    updatedSearchedMachines[index] = e.target.value;
    setSearchedMachines(updatedSearchedMachines);
  };
































































  const initialDisplaySystemState = [
    [
      'ess - electric switch systems',
      '/images/ess-map-icon.svg',
      countSwitchTreeDevices(filteredEssSwitch),
      !isEssSwitch,
      Object.keys(filteredEssSwitch),
      'ess',
    ],
    [
      'tgs - typhoon gas systems',
      '/images/tgs-map-icon.svg',
      countSwitchTreeDevices(filteredTgsSwitch),
      !isTgsSwitch,
      Object.keys(filteredTgsSwitch),
      'tgs',
    ],
    [
      'tes - typhoon electric systems',
      '/images/tes-map-icon.svg',
      countSwitchTreeDevices(filteredTesSwitch),
      !isTesSwitch,
      Object.keys(filteredTesSwitch),
      'tes',
    ],
    [
      'hp - heating platforms',
      '/images/disabled-map-icon.svg',
      countHpSegments(),
      !isHpSwitch,
      hpStations.map((station) => station.id),
      'hp',
    ],
    [
      'ate - additional track equipment',
      '/images/disabled-map-icon.svg',
      null,
      !isAteSwitch,
      null,
      'ate',
    ],
  ];

  const [systemSwitches, setSystemSwitches] = useState(
    initialDisplaySystemState
  );

  const dispatch = useDispatch();

















  useSetZoneOpeningsState(filteredEssSwitch, isEssSwitch, null, 'ess', true);
  useSetZoneOpeningsState(filteredTgsSwitch, isTgsSwitch, null, 'tgs', true);
  useSetZoneOpeningsState(filteredTesSwitch, isTesSwitch, null, 'tes', true);














































































  useEffect(() => {
    switch (selectedSystem) {
      case 'all':
        setSystemSwitches(initialDisplaySystemState);
        break;
      case 'ess':
        setSystemSwitches([initialDisplaySystemState[0]]);
        break;
      case 'tgs':
        setSystemSwitches([initialDisplaySystemState[1]]);
        break;
      case 'tes':
        setSystemSwitches([initialDisplaySystemState[2]]);
        break;
      case 'ess, tgs':
        setSystemSwitches([
          initialDisplaySystemState[0],
          initialDisplaySystemState[1],
        ]);
        break;
      case 'ess, tes':
        setSystemSwitches([
          initialDisplaySystemState[0],
          initialDisplaySystemState[2],
        ]);
        break;
      case 'tgs, tes':
        setSystemSwitches([
          initialDisplaySystemState[1],
          initialDisplaySystemState[2],
        ]);
        break;
      default:
        setSystemSwitches(initialDisplaySystemState);
        break;
    }
  }, [selectedSystem]);







  const [selectedSuggestionIdx, setSelectedSuggestionIdx] = useState(0);
  const [inputSwitchName, setInputSwitchName] = useState('');
  const [displaySuggestions, setDisplaySuggestions] = useState(false);
  const [activatedIndex, setActivatedIndex] = useState(null);
  const [machineSuggestions, setMachineSuggestions] = useState(null);
  const [displaySelectedMachine, setDisplaySelectedMachine] = useState([
    false,
    false,
    false,
    false,
    false,
  ]);























  const essMachines = getFormattedMachineName(flatEssSwitch);




  const tgsMachines = getFormattedMachineName(flatTgsSwitch);




  const tesMachines = getFormattedMachineName(flatTesSwitch);




  const machineList = [...essMachines, ...tgsMachines, ...tesMachines];


  const handleMakeSuggestions = (system) => {
    if (system === 'ess') {
      setMachineSuggestions(essMachines);
      setActivatedIndex(0);
    } else if (system === 'tgs') {
      setMachineSuggestions(tgsMachines);
      setActivatedIndex(1);
    } else {

      setMachineSuggestions(tesMachines);
      setActivatedIndex(2);
    }
  };


  const filteredSuggestions = filteredSuggestionsHandler(
    machineSuggestions,
    locations,
    inputSwitchName
  );

















  useEffect(() => {
    filteredSuggestions?.length >= 1 && inputSwitchName?.length >= 2
      ? setDisplaySuggestions(true)
      : setDisplaySuggestions(false);
  }, [filteredSuggestions, inputSwitchName]);



  const handleSelectSuggestion = useCallback(
    (index, suggestion) => {
      const arr = [...inputSearch];
      arr[index] = suggestion;
      setInputSearch(arr);

      const swtName = index === 0 ? 'ess' : index === 1 ? 'tgs' : 'tes';
      if (suggestion.length >= 2) {
        dispatch(handleOpenMasterControl({ swtName, status: false }));
      }
      if (suggestion) {
        dispatch(handleOpenMasterControl({ swtName, status: false }));

        const tempArr = [...displaySelectedMachine];
        tempArr[index] = true;
        setDisplaySelectedMachine(tempArr);
      }
      setInputSwitchName('');
      setSelectedSuggestionIdx(-1);
      setDisplaySuggestions(false);
    },
    [
      inputSearch,
      dispatch,
      displaySelectedMachine,
      inputSwitchName,
      displaySuggestions,
    ]
  );


  const handleKeyDown = (event, idx) => {
    switch (event.key) {
      case 'Escape': {
        setInputSearch('');
        break;
      }
      case 'Enter': {

        let suggestation=  selectedSuggestionIdx >=0 ? filteredSuggestions[selectedSuggestionIdx]:inputSwitchName;
       if(suggestation){
           handleSelectSuggestion(idx, suggestation);
       }

        break;
      }
      case 'ArrowUp': {
        selectedSuggestionIdx > 0
          ? setSelectedSuggestionIdx(selectedSuggestionIdx - 1)
          : setSelectedSuggestionIdx(filteredSuggestions.length - 1);
        break;
      }
      case 'ArrowDown': {
        selectedSuggestionIdx < filteredSuggestions.length - 1
          ? setSelectedSuggestionIdx(selectedSuggestionIdx + 1)
          : setSelectedSuggestionIdx(0);
        break;
      }
      default: {
        break;
      }
    }
  };


  const handleExpand = (id, swtName) => {

    const tempArr = [...inputSearch];
    tempArr[id] = '';
    setInputSearch(tempArr);


    dispatch(
      handleOpenMasterControl({
        swtName,
        status: !MCIsExpanded[swtName].masterControl,
      })
    );
  };

  const handleCancel = (idx, swtName) => {
    setInputSwitchName('');
    setSearchedMachines(['', '', '']);
    const arr = [...inputSearch];
    arr[idx] = '';
    setInputSearch(arr);
    setSelectedSuggestionIdx(-1);
    setDisplaySuggestions(false);
    dispatch(
      handleOpenMasterControl({
        swtName,
        status: true,
      })
    );
  };

  const setInputHandler = (e, swt, idx) => {
    e.target.value.length === 0 && handleCancel(idx, swt[5]);
    handleSelectSuggestion(idx, e.target.value);
    setInputSwitchName(e.target.value);
    setSelectedSuggestionIdx(-1);
  };



  return (
    <Wrapper>
      {systemSwitches.map((swt, idx) => {

        const splitName = inputSearch[idx].split(' - ');

        const isSpecificLocation = splitName.length === 3;
        const isRowDisabled = swt[3] || !swt[4];
        const isSearchDisabled = isRowDisabled || swt[5] === 'hp';
        return (
          <ContentsWrapper key={idx}>
            <SectionTitle disabled={isRowDisabled}>
              <TitleWrapper>
                <IconAndTitleWrapper>
                  <img src={swt[1]} />
                  <Title>{swt[0]}</Title>
                </IconAndTitleWrapper>
                <UnitNumber disabled={isRowDisabled}>
                  {swt[2] ? `${swt[2]} units` : '- - - - -'}
                </UnitNumber>
              </TitleWrapper>
            </SectionTitle>

            <SectionSwitch>
              <SectionInnerWrapper disabled={isRowDisabled}>
                <InputAndButtonWrapper disabled={isSearchDisabled}>
                  <SearchInput
                    type='text'
                    placeholder='search'
                    disabled={isSearchDisabled}
                    value={searchedMachines[idx]}
                    onChange={(e) => {

                      setInputHandler(e, swt, idx);
                      handleInputChange(e, idx);

                    }}






                    onKeyDown={(e) => handleKeyDown(e, idx, swt[5])}

                    onClick={() => {
                       handleMakeSuggestions(swt[5]);


                    }}
                  />
                  <SearchButtonHole
                    disabled={isSearchDisabled}
                    onClick={() => isSearchDisabled || handleCancel(idx, swt[5])}
                  >
                    <SearchButtonInner disabled={isSearchDisabled}>
                      <SearchButtonTop disabled={isSearchDisabled}>clear</SearchButtonTop>
                    </SearchButtonInner>
                  </SearchButtonHole>
                </InputAndButtonWrapper>
                <SearchIcon
                  onClick={() => {
                    if (isSearchDisabled) return;
                       let suggestation=  selectedSuggestionIdx >=0 ? filteredSuggestions[selectedSuggestionIdx]:inputSwitchName;
                        if(suggestation){
                            handleSelectSuggestion(idx, suggestation);
                        }

                    }}>
                  <Img
                    src={
                      swt[3]
                        ? '/images/search-icon.svg'
                        : '/images/search-icon.svg'
                    }
                  />
                </SearchIcon>
                <SearchButtonWrapper disabled={isRowDisabled}>
                  <SearchButtonHole
                    onClick={() => isRowDisabled || handleExpand(idx, swt[5])}
                    disabled={isRowDisabled}
                  >
                    <SearchButtonInner disabled={isRowDisabled}>
                      <SearchButtonTop disabled={isRowDisabled}>
                        {MCIsExpanded[swt[5]].masterControl
                          ? `close`
                          : `expand`}
                      </SearchButtonTop>
                    </SearchButtonInner>
                  </SearchButtonHole>
                </SearchButtonWrapper>
              </SectionInnerWrapper>
              {displaySuggestions && (
                <AutoCompleteWrapper
                  isTrue={idx === activatedIndex}
                  onMouseMove={() => setSelectedSuggestionIdx(-1)}
                >
                  <AutoCompleteInnerWrapper isTrue={idx === activatedIndex}>
                    {filteredSuggestions.map((suggestion, index) => {
                      let isSelected =
                        filteredSuggestions.indexOf(suggestion) ===
                        selectedSuggestionIdx
                          ? true
                          : false;

                      return (
                        <DisplayMachineSuggestion
                          swtName={swt[5]}
                          key={index}
                          column={idx}
                          matchedSuggestion={suggestion}
                          isSelected={isSelected}
                          handleSelect={handleSelectSuggestion}
                          index={index}
                          handleClose={() => {
                            setDisplaySuggestions(false);
                            setInputSwitchName('');
                          }}
                        />
                      );
                    })}
                  </AutoCompleteInnerWrapper>
                </AutoCompleteWrapper>
              )}
            </SectionSwitch>
            {MCIsExpanded[swt[5]].masterControl && swt[4] && (
              <LocationScrollWrapper>
                <SelectionLocation>
                  {swt[5] === 'hp'
                    ? hpStations.map((station, idx) => (
                        <HpStationLocation
                          key={station.id}
                          station={station}
                          index={idx}
                          isExpanded={
                            MCIsExpanded.hp.isLocationOpen[idx] || false
                          }
                        />
                      ))
                    : swt[4].map((location, idx) => (
                    <SwitchLocation
                      key={Math.random() * 10000}
                      index={idx}
                      location={location}
                      isExpanded={MCIsExpanded[swt[5]].isLocationOpen[idx]}
                      isSpecificLocationExpanded={
                        MCIsExpanded[swt[5]].isSpecificLocationOpen
                      }
                      id={swt[5]}
                      system={
                        swt[5] === 'ess'
                          ? filteredEssSwitch
                          : swt[5] === 'tgs'
                          ? filteredTgsSwitch
                          : swt[5] === 'tes'
                          ? filteredTesSwitch
                          : null
                      }
                      setCenter={setCenter}
                      setZoomNum={setZoomNum}
                       mapCenter={mapCenter}
                       zoomNum={zoomNum}
                       selectedLocation={selectedLocation}
              setSelectedLocation={setSelectedLocation}
                    />
                      ))}
                </SelectionLocation>
              </LocationScrollWrapper>
            )}
            {displaySelectedMachine[idx] &&
              inputSearch[idx] &&
              machineList.includes(inputSearch[idx]) && (
                <DisplaySearchedMachineWrapper>
                  <IndividualMachine
                    location={splitName[0]}
                    setSearchedMachine={setSearchedMachines}
                    specificLocation={isSpecificLocation ? splitName[1] : null}
                    machine={isSpecificLocation ? splitName[2] : splitName[1]}
                    swtName={swt[5]}
                    setCenter={setCenter}
                    setZoomNum={setZoomNum}
                  />
                </DisplaySearchedMachineWrapper>
              )}
          </ContentsWrapper>
        );
      })}
    </Wrapper>
  );
};

export default IntegratedSystem;

const Wrapper = styled.div`
  width: 531rem;
  min-height: 590rem;
  border-radius: 11px;

  ${layerA180Deg}
  padding: 5rem 0;

  display: flex;
  flex-direction: column;
  align-items: center;

`;

const ContentsWrapper = styled.div`
  margin-bottom: 8rem;

  &:last-child {
    margin-bottom: 0rem;
  }
`;
const SectionTitle = styled.section`
  width: 524px;
  height: 24px;
  border-radius: 14px;

  ${layerBDark}

  padding: 0 8rem;
  margin-bottom: 2rem;

  ${(p) =>
    p.disabled &&
    css`
      ${layerBDisabled}
    `}
`;
const TitleWrapper = styled.div`
  height: 100%;
  ${justifyContentSpaceBetween}
`;

const IconAndTitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Title = styled.span`
  font-size: 10rem;
  margin-left: 6rem;
`;
const SectionSwitch = styled.section`
  width: 524px;
  height: 30px;
  border-radius: 17px;

  ${layerC}
  ${flexBoxCenter}

  margin-bottom: 2rem;
  position: relative;
`;

const SectionInnerWrapper = styled.div`
  width: 522px;
  height: 28px;
  border-radius: 16px;

  ${layerA180Deg}
  ${justifyContentSpaceBetween}
  padding: 0 3px 0 3px;

  ${(p) =>
    p.disabled &&
    css`
      ${layerADisabled180Deg}
    `}
`;

const InputAndButtonWrapper = styled.div`
  width: 383px;
  height: 22px;
  border-radius: 13px;

  ${layerADark}
  ${justifyContentSpaceBetween}
  padding: 0 1rem 0 10rem;

  ${(p) =>
    p.disabled &&
    css`
      ${layerBDisabled}
    `}
`;

const SearchInput = styled.input`
  background-color: transparent;
  font-size: 10rem;
  text-align: left;
  letter-spacing: 1rem;
  text-transform: uppercase;

  ::placeholder {
    color: #fff;
    ${(p) =>
      p.disabled &&
      css`
        color: #808080;
      `}
  }
`;
const SearchButtonWrapper = styled.div`
  width: 78px;
  height: 22px;
  border-radius: 13px;

  ${layerC};
  ${flexBoxCenter};
  ${(p) =>
    p.disabled &&
    css`
      ${layerBDisabled};
    `}
`;
const SearchButtonHole = styled.button`
  width: 76px;
  height: 20px;
  border-radius: 12px;

  ${layerA180Deg};
  ${flexBoxCenter};

  ${(p) =>
    p.disabled &&
    css`
      ${layerADisabled180Deg}
      cursor: not-allowed;
    `}
`;
const SearchButtonInner = styled.div`
  width: 72px;
  height: 16px;
  border-radius: 13px;

  ${layerC};
  ${flexBoxCenter};

  ${(p) =>
    p.disabled &&
    css`
      ${layerBDisabled}
    `}
`;
const SearchButtonTop = styled.div`
  width: 70px;
  height: 14px;
  border-radius: 12px;

  ${flexBoxCenter};
  ${layerA180Deg};
  font-size: 10rem;

  ${(p) =>
    p.disabled &&
    css`
      ${layerADisabled180Deg}
      color: #808080;
    `}
`;

const SearchIcon = styled.div`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  cursor:pointer;


  ${layerADark}
  ${flexBoxCenter}

  ${(p) =>
    p.disabled &&
    css`
      ${layerBDisabled}
    `}
`;

const Img = styled.img`
  width: 60%;
`;

const LocationScrollWrapper = styled.div`
  width: 524px;
  min-height: 55px;
  max-height: 150px;
  border-radius: 8px;
  ${layerBDark};

  padding: 4px;
`;

const SelectionLocation = styled.section`
  width: 100%;
  min-height: 55px;
  max-height: 142px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  scroll-behavior: smooth;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 10px;
    border: 1px solid #ffffff;
    border-radius: 13px;
  }
  ::-webkit-scrollbar-track {
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 13px;
    border: 1.5px solid transparent;
    background-clip: padding-box;
    height: 40%;
  }

  ::-webkit-scrollbar-button:start:decrement {
    background-repeat: no-repeat;
    background-size: 65%;
    background-position: center;
    height: 10px;

    background-image: url('/images/scrollbar-button-start.svg');
  }
  ::-webkit-scrollbar-button:end:increment {
    background-repeat: no-repeat;
    background-size: 65%;
    background-position: center;
    height: 10px;

    background-image: url('/images/scrollbar-button-end.svg');
  }
`;

const DisplaySearchedMachineWrapper = styled.section`
  width: 524rem;
  border-radius: 8px;
  ${layerBDark}
  padding: 4rem 0;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

const UnitNumber = styled.span`
  font-size: 10rem;
  ${(p) =>
    p.disabled &&
    css`
      color: #808080;
    `}
`;

const AutoCompleteWrapper = styled.ul`
  width: 300rem;
  border-radius: 12px;

  padding: 2rem 2rem;
  text-align: left;

  position: absolute;

  top: 30rem;
  left: 2rem;

  z-index: 100;

  display: flex;
  flex-direction: column;

  ${layerA180Deg}

  ${(p) =>
    p.isTrue ||
    css`
      display: none;
    `}
`;

const AutoCompleteInnerWrapper = styled.div`
  width: 100%;
  border-radius: 11px;

  ${layerB}
  padding: 2rem 2rem;

  ${(p) =>
    p.isTrue ||
    css`
      display: none;
    `}
`;
